import {Pipe, PipeTransform} from '@angular/core';
import {Team} from "@team/model";

@Pipe({
  name: 'teamSortInHierarchy'
})
export class TeamSortInHierarchyPipe implements PipeTransform {
  memo: Map<string, string> = new Map<string, string>();

  transform(value: Team[]): Team[] {
    return value.sort((a, b) => {
      return this.teamStr(a).localeCompare(this.teamStr(b));
    });
  }

  private teamStr(value: Team): string {
    if(this.memo.has(value.id)) {
      return this.memo.get(value.id)!;
    }

    if (!value.isStructural) {
      this.memo.set(value.id, value.name);
      return value.name;
    }

    let str = value.name;
    let parent = value.parent;

    while (parent) {
      str = `${parent.name} / ${str}`;
      parent = parent.parent;
    }

    this.memo.set(value.id, str);
    return str;
  }
}
